import basketPopupController from './controllers/basket.popup.controller';

import basketPopupService from './services/basket.popup.service';

import basketPopupComponent from './components/basket.popup.component';

let popupModule = angular.module('spabooker.popup', [ ])
    .controller('basketPopupController', basketPopupController)

    .factory('basketPopupService', basketPopupService)

    .component('basketPopup', basketPopupComponent)
;

export default popupModule.name;


// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/popup/index.js